/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { combineReducers } from 'redux';
import { call } from 'redux-saga/effects';
import * as CurrentChannel from './currentChannel';
import * as ChannelFilters from './channelFilters';
import * as FilterChannels from './filterChannels';

export default combineReducers({
  currentChannel: CurrentChannel.default,
  channelFilters: ChannelFilters.default,
  filterChannels: FilterChannels.default,
});

export const sagas = [call(CurrentChannel.saga), call(ChannelFilters.saga), call(FilterChannels.saga)];
